import React from 'react';
import './styles.css';
import logo from '../../assets/images/logo.png';

const Logo = props => {
  const { btnStyles } = props;
  return (
    <a className="logo" style={btnStyles} href="/">
      <img className="logo__image" src={logo} alt="GoBuyside" />
    </a>
  );
};

export default Logo;
